import { FC, useState } from "react";
import { Tooltip, Box, TooltipProps, useTheme } from "@mui/material";

const OverlayTooltip: FC<Pick<TooltipProps, "placement" | "title" | "children">> = ({
  children,
  title,
  placement,
}) => {
  const [open, setOpen] = useState(false);

  const theme = useTheme();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Tooltip
        title={title}
        open={open}
        disableInteractive
        disableHoverListener
        disableFocusListener
        placement={placement}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: `${theme.palette.background.default} !important`,
              padding: "8px",
              border: `1px solid ${
                theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.2)" : "rgba(21, 21, 21, 0.2)"
              } !important`,
            },
          },
        }}
      >
        <Box onClick={handleOpen}>{children}</Box>
      </Tooltip>

      {open && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          }}
          onClick={handleClose}
        />
      )}
    </Box>
  );
};

export default OverlayTooltip;
